<template>
    <div class="hpAgenda reveal">
        <div class="container">
            <div class="split-text section-title ___title">
                <p>CONFERENCE SCHEDULE</p>
            </div>  
            <div class="cols">
                
                <!-- day -->
                <div class="item">
                    <div class="fxNoCircleNum col1" style="--index:0"><span>12</span></div>
                    
                    <div class="fxWaveLine" style="--index:1">
                        <!-- <img src="img/svg/line_yellow.svg" /> -->
                        <img src="img/palma/stroke.png" />
                    </div>
                    
                    <div class="itemTop">
                        <div class="fxTextUp title"><div class="fxText fs16" style="--index:0">Thursday, September 12</div></div>
                        <div class="fxTextUp"><div class="fxText fs14" style="--index:1">Workshops</div></div>
                        <div class="fxTextUp"><div class="fxText fs14" style="--index:2">Welcome Event</div></div>                    
                    </div>

                    <div class="fxxIcon fxCocktail" style="--index:3">
                        <img src="img/svg/cocktail_icon.svg" />
                        <!--
                            <span class="bbl" style="--index:0;--posY:36px;--posX:-1px"></span>
                            <span class="bbl" style="--index:1;--posY:33px;--posX:-1px"></span>
                            <span class="bbl" style="--index:2;--posY:33px;--posX:-3px"></span>
                            <span class="bbl" style="--index:3;--posY:33px;--posX:3px"></span>
                            <span class="bbl" style="--index:4;--posY:30px;--posX:-1px"></span>
                            <span class="bbl" style="--index:5;--posY:30px;--posX:-3px"></span>
                            <span class="bbl" style="--index:6;--posY:30px;--posX:3px"></span>
                            <span class="bbl" style="--index:7;--posY:27px;--posX:-1px"></span>
                            <span class="bbl" style="--index:8;--posY:27px;--posX:-4px"></span>
                            <span class="bbl" style="--index:9;--posY:27px;--posX:4px"></span>
                            <span class="bbl" style="--index:10;--posY:27px;--posX:7px"></span>
                        -->
                    </div>
<!--                     <div class="fxTextUp"><div class="fxText" style="--index:4"><b>Welcome cocktail</b></div></div>
                    <div class="fxTextUp"><div class="fxText" style="--index:5">7:30 PM - Arena Hall</div></div>-->
                 </div>


                <div class="item">
                    <div class="fxNoCircleNum col2" style="--index:1"><span>13</span></div>
                    <div class="fxWaveLine" style="--index:2">
                        <!-- <img src="img/svg/line_green.svg" /> -->
                        <img src="img/palma/stroke.png" />
                    </div>

                    <div class="itemTop">
                        <div class="fxTextUp title"><div class="fxText fs16" style="--index:3">Friday, September 13</div></div>                                                
                        <div class="fxTextUp"><div class="fxText fs14" style="--index:5">Scientific Program – Day 1</div></div>
                        <!--                     <div class="fxTextUp"><div class="fxText" style="--index:6">8:30 AM - Azul Hall</div></div>                         
                        <div class="fxxIcon fxDisco" style="--index:7"><img src="img/svg/disco_icon.svg" /></div>
                        <div class="fxTextUp"><div class="fxText" style="--index:8"><b>Conference closing event</b></div></div>                    
                        <div class="fxTextUp"><div class="fxText" style="--index:9">9:00 PM - Arena Hall</div></div>-->
                    </div>

                    <div class="fxxIcon fxSci" style="--index:4"><img src="img/svg/icon_atom.svg" /></div>
                </div>


                <div class="item">
                    <div class="fxNoCircleNum col3" style="--index:2"><span>14</span></div>
                    <div class="fxWaveLine" style="--index:3"><img src="img/palma/stroke.png" /></div>
                    
                    <div class="itemTop">
                        <div class="fxTextUp title"><div class="fxText fs16" style="--index:4">Saturday, September 14</div></div>
                        <div class="fxTextUp"><div class="fxText fs14" style="--index:5">Scientific Program – Day 2</div></div>
                        <div class="fxTextUp"><div class="fxText fs14" style="--index:7">Closing Event</div></div>
                    </div>                    
                    
                    <div class="fxxIcon fxDisco" style="--index:7"><img src="img/svg/disco_icon.svg" /></div>
                    <!-- <div class="fxTextUp"><div class="fxText" style="--index:8">For extended stay guests</div></div> -->
                </div>


                <div class="item">
                    <div class="fxNoCircleNum col4" style="--index:2"><span>15</span></div>
                    <div class="fxWaveLine" style="--index:3"><img src="img/palma/stroke.png" /></div>
                    
                    <div class="itemTop">
                        <div class="fxTextUp title"><div class="fxText fs16" style="--index:4">Sunday, September 15</div></div>
                        <div class="fxTextUp"><div class="fxText fs14" style="--index:5">Departure</div></div>
                    </div>
                    <div class="fxxIcon fxBus" style="--index:6"><img src="img/svg/bus_icon.svg" /></div>                    
                    <!--<div class="fxTextUp"><div class="fxText" style="--index:7"><b>Guided day tours</b></div></div>
                    <div class="fxTextUp"><div class="fxText" style="--index:8">For extended stay guests</div></div>-->
                </div>


                <!-- more days 
                <div class="item" v-if="isMainVersion===false">
                    <div class="fxNoCircleNum col4" style="--index:3">
                        <span>22</span>
                    </div>
                    <div class="fxWaveLine" style="--index:4">
                        <img src="img/svg/line_brown.svg" />
                    </div>
                    <div class="fxTextUp title"><div class="fxText" style="--index:0">Tuesday, November 22</div></div>
                    <div class="fxTextUp"><div class="fxText" style="--index:1">Free time</div></div>
                </div>
                <div class="item" v-if="isMainVersion===false">
                    <div class="fxNoCircleNum col5" style="--index:4">
                        <span>23</span>
                    </div>
                    <div class="fxWaveLine" style="--index:5">
                        <img src="img/svg/line_orange.svg" />
                    </div>
                    <div class="fxTextUp title"><div class="fxText" style="--index:0">Wednesday, November 23</div></div>
                    <div class="fxTextUp"><div class="fxText" style="--index:1"><b>Guided day tours</b></div></div>
                    <div class="fxTextUp"><div class="fxText" style="--index:2">For extended stay guests</div></div>
                    <div class="fxTextUp"><div class="fxText" style="--index:3">Departure</div></div>
                </div>

                -->

            </div>

            <div class="xrBtn viewSciBtn">
                <a class="white_btn animation_up" @click="scrollToNextSection" >
                    <span class="title">View scientific program</span>
                    <i class="fal fa-chevron-down pl-s" ></i>
                </a>
            </div>

        </div>
    </div>
</template>

                        <!--
                        <div v-if="isMainVersion==false" class="fxText" style="--index:1">
                            <a class="linkWhite" href="https://storage.googleapis.com/forms-wizard-biz-uploads/forms-wizard/60/ckeditor_assets/attachments/7404/1ac3a7d35fbb8eaebde0622c9c3aed42c27e8c84.pdf" target="_blank">
                            Guided day-tours <span class="fxPlus">+</span>
                            </a>
                        </div>-->




<style>    
    .hpAgenda
    {
      width: 100%;
    }
    .hpAgenda .container
    {
      max-width: 1800px;
      width: 70vw;
    }
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/

  .hpAgenda .split-text.subtitle .xLine .xLineText
  {
    font-weight: 300 !important;
  }
  .hpAgenda .split-text.title .xLine .xLineText
  {
    font-weight: 200 !important;
  }


    .hpAgenda .cols
    {
        padding-top: 60px;
        width: 100%;
        margin: auto;

        /*
        display: flex;
        grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
        grid-auto-rows: 20px;
        grid-gap: 5px;
        */

        display: grid;
        grid-template-columns: repeat(4, minmax(115px, 1fr));      
        max-width: 1800px;
        grid-row-gap: 2rem; /* Will be used instead by browsers that do not support `row-gap` */
        row-gap: 10px; /* Used by browsers that support `row-gap` */

    }
    .hpAgenda .cols .item 
    {
        text-align: left;
        border: solid 0px #fff;
        padding-bottom: 30px;
        width: 100%;
    }    
    .hpAgenda .cols .item .itemTop
    {
        height: 90px;
        min-height: 90px;
        padding-top: 25px;
        min-height: 120px;
        /* border: solid 1px red; */
    }    

    .hpAgenda.reveal .fxxIcon
    {        
        clear: both;
        text-align: center;
        padding-top: 20px;
        transform: translateY(15px);
        transition-delay: calc(0.2s + (0.2s * var(--index))) !important;
        transition: all ease 0.5s;
        opacity: 0;   
        position: relative;
        height: 70px;        
        /* border: solid 2px yellow; */
    }
    .hpAgenda.reveal.active .fxxIcon
    {
        transform: translateY(0px);
        opacity: 1;
    }
    .hpAgenda .fxxIcon img
    {
        height: 40px;width: auto;
        position: absolute;
        top:50%;
        left: 50%;
        transform: translate(-50%,-50%);
    }

    .hpAgenda .fxxIcon.fxCocktail
    {
        position: relative;
    }
    .hpAgenda .fxxIcon.fxCocktail .bbl
    {
        height: 2px;
        width: 2px;
        background-color: #fff;
        border-radius: 50%;
        display: inline-block;
        position: absolute;        
        left:55%;
        top:var(--posY);
        left: calc(50% + var(--posX));
        animation-delay: calc(0.1s + (0.15s * var(--index))) !important;
        animation: bubble 2s infinite;
        animation-fill-mode:forwards;
    }
    .hpAgenda .fxxIcon.fxCocktail img
    {
        height: 50px;width: auto;
    }
    @keyframes bubble {
        0% {transform: translateY(4px);opacity: 0.1;}  
        50% {transform: translateY(2px);opacity: 0.7;}
        100% {transform: translateY(-5px);opacity: 0.1;}  
    }


    .hpAgenda .fxxIcon.fxSci img
    {
        height: 50px;width: auto;
    }
    .hpAgenda .fxxIcon.fxDisco
    {
        margin-top: 0px;
    }
    .hpAgenda .fxxIcon.fxDisco img
    {
        height: 55px;width: auto;
    }
    .hpAgenda .fxxIcon.fxBus img
    {
        height: 50px;width: auto;
    }
    .hpAgenda .fxTextUp
    {
        overflow: hidden;
    }
    .hpAgenda .fxSep
    {
        line-height: 1px;
        max-height: 1px;
        padding-top: 15px;
    }






    .linkWhite
    {
        color: #fff !important;
    }
    .linkWhite:hover
    {
        text-decoration: underline;
    }


    .hpAgenda .fxTextUp .fxText
    {
        opacity: 0;
        position: relative;
        padding-bottom: 5px;
        font-weight: 100;
    }
    .hpAgenda .cols .item .fxTextUp.title .fxText {
        /* font-size: 18px; */
        font-weight: 500 !important;
        padding-bottom: 10px;
        text-align: center;
    }
    .hpAgenda .cols .item .fxTextUp.expend .fxText {
        font-weight:inherit;
    }
    .hpAgenda .cols .item .fxTextUp.expend .fxText i{
        font-size: 12px;
    }

    .hpAgenda.reveal.active .fxTextUp div
    {
        animation-delay: calc(0.4s + (0.15s * var(--index))) !important;
        animation: textUp 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        animation-fill-mode:forwards;
        text-align: center;
    }    
    @keyframes textUp {
        from {transform: translateY(40px);opacity: 0;}  
        to {transform: translateY(0);opacity: 1;}
    }

    .fxCircleNum
    {
        opacity: 0;
        border: solid 3px #8dbbdb;
        border-radius: 100%;
        width: 90px;
        height: 90px;
        align-items: center;
        text-align: center;
        margin: auto;
        margin-bottom: 20px;
        transform: translate(-50%,20px);
        padding-top: 19px;
        transition: all ease-out 0.6s;
        transition-delay: calc(0.1s * var(--index)) !important;
    }
    .fxCircleNum span:nth-child(1)
    {
        position: relative;
        font-size: 33px;
        line-height: 33px;
        font-weight: 800 !important;  
        display: block;      
        height: 30px;
        overflow: hidden;
        clear: both;
    }
    .fxCircleNum span:nth-child(2)
    {
        display: block;      
        font-size: 11px;
        line-height: 12px;
        font-weight: 500 !important;        
        opacity: 0.7;
    }
    .hpAgenda.reveal.active .fxCircleNum
    {
        opacity: 1;
        transform: translate(-50%,0px);
    }    

    .fxNoCircleNum
    {
        opacity: 0;
        width: 90px;
        height: clamp(40px,4vw,100px); 
        align-items: center;
        text-align: center;
        margin: auto;
        margin-bottom: 0px;
        transition: all ease-out 0.5s;
        transition-delay: calc(0.22s * var(--index)) !important;
    }
    .hpAgenda.reveal.active .fxNoCircleNum
    {
        opacity: 1;
    }    



    .fxNoCircleNum span
    {
        font-size: clamp(40px,4vw,100px) !important;  
        line-height: clamp(40px,4vw,100px) !important;  
        letter-spacing: -5px !important;
        font-weight: 400 !important;          
        display: block;      
        clear: both;
    }

    .fxNoCircleNum.col1 span
    {
        color: #afe2fa;
    }
    .fxNoCircleNum.col2 span
    {
        color: #f37d74;
    }
    .fxNoCircleNum.col3 span
    {
        color: #b27fbb;
    }
    .fxNoCircleNum.col4 span
    {
        color: #1bb3e8;
    }
    .fxNoCircleNum.col5 span
    {
        color: #d88f38;
    }


    .fxWaveLine
    {
        padding-bottom: 10px;
        text-align:center;
        transition: all ease-out 0.9s;
        transition-delay: calc(0.2s * var(--index)) !important; 
        opacity: 0;       
        transform: scale(0.9);
        position: relative;
        height: 30px;
    }
    .fxWaveLine img
    {
        max-width: 200px;
        position: absolute;
        left: 50%;
        top: -20px;
        transform: translateX(-50%);
    }
    .hpAgenda.reveal.active .fxWaveLine
    {
        opacity: 1;
        transform: scale(1);
    }    



  /* LARGE SCREENS */
  @media (min-width: 1600px) 
  {
    .hpAgenda.reveal .fxxIcon {
        transform-origin: top center;
    }    
    .hpAgenda.reveal.active .fxxIcon {
        transform-origin: top center;
        transform: translateY(0px) scale(1.5);
        opacity: 1;        
    }    
    .hpAgenda .cols .item .itemTop {
        height:auto;
        min-height: 6.5vw;
    }
    .hpAgenda .cols {
        padding-bottom: 50px;
    }
  }      


  @media (max-width: 850px) { 
    .hpAgenda .container
    {
      width: 92vw !important;
    }
    .hpAgenda .split-text.title div
    {
        font-size: 24px !important;
        line-height: 24px;
    }

    .hpAgenda .cols
    {
        padding-top: 20px;
        display: block;
        margin: auto;
        width: 100%;
        padding-top: 50px;
    }
    .hpAgenda .cols .item
    {
        width: 100%;
        padding-bottom: 80px;
    }
    .hpAgenda .fxCircleNum {
        transform: translate(0,0);
        margin: initial;
        margin: auto;
    }
    .hpAgenda.reveal.active .fxCircleNum {
        transform: translate(0,0);
    }    
    .hpAgenda .fxTextUp div
    {
        text-align: center;
    }

    .hpAgenda .xrBtn
    {
        width: 100%;
    }
    .hpAgenda .cols .item .fxTextUp.title {
        padding-top: 10px;        
    }

    .hpAgenda .fxxIcon.fxCocktail
    {
        position: relative;
        top: 20px;
    }
    .viewSciBtn a
    {
        margin: auto;
    }
  }

</style>
<script>

export default {
  computed: {
    isMainVersion()
    {
        return this.$route.path.toLowerCase() == "/v2" ? false : true;
    }
  },
  methods:
  {
    scrollToNextSection()
    {
      this.isMenuOpen=false;
      document.getElementById("hpProgram").scrollIntoView({ 
        behavior: 'smooth' 
      });
    }
  }
};
</script>

